// Shoplist
Shoplist = (function(){
	
	// constructor
	var Shoplist = function(opt){
		if(!(this instanceof Shoplist)) {
			return new Shoplist(opt);
		}
		
		this.opt = {
			csv_filename:null	// csvファイル名
			,shoplistArea:null	// append位置
			,header_item_row:0	// item名称行
			,data_start_row:1	// データ開始行
			,data_area_col:0	// 地域列
			,data_name_col:null	// 店名列
			,data_zip_col:null	// 郵便番号列
			,data_pref_col:null	// 都道府県列
			,data_address_col:null	// 住所列
			,data_tel_col:null	// TEL列
			,data_item_start_col:null	// item開始列
			,tmplArea:''
			,tmplHead:''
			,tmplHeadItem:''
			,tmplBody:''
			,tmplBodyItem:''
			,csvErrorhtml:'<p class="error">ショップリストが読み込めませんでした。</p>'
			,complete:null
		};
		
		this.shopList = null;
		this.header = [];
		this.areaList = [];
		
		if(opt) this.opt = $.extend(true, this.opt, opt);
		
		if(!this.opt.csv_filename || !this.opt.shoplistArea) return false;
		
		this.init();
	}
	
	// prototype
	var _prototype = Shoplist.prototype;
	
	// init
	_prototype.init = function(){
		var _this = this;
		
		// csv読み込み
		$.ajax({
			cache:false,
			dataType:'text',
			url:_this.opt.csv_filename
		})
		.done(function(data){
			var csvData;
			
			// jquery.csv
			$.csv.toArrays(data, {}, function(err, data){
				for(var i = 0; i < data.length; i++){
					var exist = false;
					for(var j = 0; j < data[i].length; j++){
						data[i][j] = (data[i][j]+'').trim();		// trim
						if(data[i][j] != '') exist = true;
					}
					// 空行を削除
					if(!exist){
						data.splice(i, 1);
						i--;
					}
				}
				// 末尾空列を削除
				while(1){
					var j = data[0].length - 1;
					if(j < 0) break;
					var exist = false;
					for(var i = 0; i < data.length; i++){
						if(data[i][j]){
							exist = true;
							break;
						}
					}
					if(exist){
						break;
					}else{
						for(var i = 0; i < data.length; i++){
							data[i].pop();
						}
					}
				}
				csvData = data;
			});
			
			// データが空の場合
			if(csvData.length <= _this.opt.data_start_row){
				_this.csvError();
				return;
			}
			
			// ヘッダー格納
			for(var i = 0; i < _this.opt.data_start_row; i++){
				_this.header.push(csvData[i]);
			}
			
			// 店舗リスト格納
			_this.shopList = csvData.slice(_this.opt.data_start_row);
			
			// 地域リスト格納
			$.each(_this.shopList, function(shopId){
				var area = _this.shopList[shopId][_this.opt.data_area_col];
				var exist = false;
				for(var i = 0; i < _this.areaList.length; i++){
					if(_this.areaList[i] == area){
						exist = true;
						break;
					}
				}
				if(!exist) _this.areaList.push(area);
			});
			
			// 店舗HTMLデータ生成
			_this.storeShopdata();
			
			// on complete
			if(_this.opt.complete && typeof _this.opt.complete == 'function') _this.opt.complete();
			
		})
		.fail(function(jqXHR, textStatus, errorThrown){
			// csv読み込みエラー
			_this.csvError();
		});
	};
	
	// 店舗HTMLデータ生成
	_prototype.storeShopdata = function(){
		var _this = this;
		
		// 地域ヘッダーHTML生成
		var head_ht = '';
		var header = _this.header;
		var header_items = '';
		// 地域ヘッダー内アイテム
		if(_this.opt.data_item_start_col){
			$.each(header[_this.opt.header_item_row], function(headerId){
				if(headerId < _this.opt.data_item_start_col) return;
				var title = _this.html(header[_this.opt.header_item_row][headerId]);
				header_items += eval(_this.opt.tmplHeadItem);	// 地域ヘッダー内アイテムテンプレート
			});
		}
		head_ht = eval(_this.opt.tmplHead);	// 地域ヘッダーテンプレート
		
		// 地域リスト毎
		$.each(_this.areaList, function(areaId){
			var area_id = 'shoplistArea'+areaId;
			var area_name = _this.areaList[areaId];
			
			var body_ht = '';
			
			// 店舗リスト毎
			$.each(_this.shopList, function(shopId){
				// 店舗ブロックHTML生成
				if(_this.shopList[shopId][0] != area_name) return;
				if(_this.opt.data_name_col) var name = _this.html(_this.shopList[shopId][_this.opt.data_name_col]);
				if(_this.opt.data_zip_col) var zip = _this.html(_this.shopList[shopId][_this.opt.data_zip_col]);
				if(_this.opt.data_pref_col) var pref = _this.html(_this.shopList[shopId][_this.opt.data_pref_col]);
				if(_this.opt.data_address_col) var address = _this.html(_this.shopList[shopId][_this.opt.data_address_col]);
				if(_this.opt.data_tel_col) var tel = _this.html(_this.shopList[shopId][_this.opt.data_tel_col]);
				var body_items = '';
				// 店舗ブロック内アイテム
				if(_this.opt.data_item_start_col){
					$.each(_this.shopList[shopId], function(recId){
						if(recId < _this.opt.data_item_start_col) return;
						var title = _this.html(header[_this.opt.header_item_row][recId]);
						var item = _this.shopList[shopId][recId].match(/[○〇◯]/) ? '○' : '';
						body_items += eval(_this.opt.tmplBodyItem);	// 店舗ブロック内アイテムテンプレート
					});
				}
				body_ht += eval(_this.opt.tmplBody);	// 店舗ブロックテンプレート
			});
			// append
			$(_this.opt.shoplistArea).append(eval(_this.opt.tmplArea));	// 地域ブロックテンプレート
		});
		
	};
	
	// csv読み込みエラー
	_prototype.csvError = function(){
		var _this = this;
		$(_this.opt.shoplistArea).append(_this.opt.csvErrorhtml);
	};
	
	// htmlエスケープ処理
	_prototype.html = function(str){
		str = str.replace(/&/g, '&amp;');
		str = str.replace(/>/g, '&gt;');
		str = str.replace(/</g, '&lt;');
		str = str.replace(/"/g, '&quot;');
		str = str.replace(/'/g, '&#x27;');
		str = str.replace(/`/g, '&#x60;');
		return str;
	};
	
	return Shoplist;
	
})();
